
import { Component, Vue } from 'vue-property-decorator'
import { mapState } from 'vuex'

@Component({ computed: { ...mapState('auth', ['user']) } })
export default class ObserverDashboard extends Vue {}
